import { ChangeDetectionStrategy, Component, computed, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { Tags } from '../../interfaces';
import { comment } from '../../utils';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-chip',
  imports: [TranslatePipe],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChipComponent {
  /* Inputs */
  tag: InputSignal<Tags> = input.required();
  removable: InputSignal<boolean> = input(false);
  /* Outputs */
  onRemove: OutputEmitterRef<Tags> = output();
  /* Computed Signals */
  bgColor = computed(() => this.getInvestigationBgColor(this.tag().name))
  icon = computed(() => this.getInvestigationIcon(this.tag().name))

  constructor() { }

  protected removeTag() {
    this.onRemove.emit(this.tag())
  }

  private getInvestigationBgColor(invComment: string | undefined) {
    if (invComment == undefined) {
      return 'none';
    }
    if (invComment.toLowerCase() === 'suspicious') {
      return 'bg-warning text-dark';
    }
    if (
      invComment == comment.WASTE ||
      invComment == comment.ABUSE ||
      invComment == comment.FRAUD ||
      invComment == comment.PROVEN ||
      invComment == comment.PREEXISTINGDAMAGE ||
      invComment == comment.POSTACCIDENTINSURANCE ||
      invComment == comment.INFLATEDCHARGES
    ) {
      return 'bg-danger text-white';
    } else {
      return 'bg-success text-white';
    }
  }

  private getInvestigationIcon(invComment: string | undefined): string {
    if (invComment == undefined) {
      return 'none';
    }
    if (invComment.toLowerCase() == 'waste') {
      return 'fa-solid fa-dumpster text-white';
    } else if (invComment.toLowerCase() == 'abuse' || invComment.toLowerCase() == 'suspicious') {
      return 'fa-solid fa-certificate text-white';
    } else if (invComment.toLowerCase() == 'fraud' || invComment.toLowerCase() == 'proven' || invComment.toLowerCase() == 'preexistingdamage' || invComment.toLowerCase() == 'postaccidentinsurance' || invComment.toLowerCase() == 'inflatedcharges') {
      return 'fa-solid fa-mask text-white';
    } else if (invComment.toLowerCase() == 'acceptable' || invComment.toLowerCase() == 'nofraud') {
      return 'fa-solid fa-check text-white';
    }
    return '';
  }


}
